<template>
  <div>
    <div>
      <b>{{ version.date }}</b>
    </div>
    <div>
          <span v-if="version.field === 'keywords'">
            <b>{{ version.author }}</b>
            <span v-html="keywordsDiffText(version.oldValue, version.newValue, 'keywords')"></span>
          </span>
      <span v-if="version.field === 'tag_id'">
            <b>{{ version.author }}</b>
            <span v-html="tagsDiffText(version.oldValue, version.newValue)"></span>
          </span>

      <span v-if="version.field === 'category_id'">
            <b>{{ version.author }}</b>
            <span v-html="categoriesDiffText(version.oldValue, version.newValue)"></span>
          </span>
      <span v-if="['name', 'caption', 'usage', 'location', 'copyright'].includes(version.field)">
                <b>{{ version.author }}</b> changed
                <b>{{ version.field }}</b> to
                <b>{{ version.newValue }}</b>
            </span>
      <span v-if="version.field === 'exclusive'">
                <b>{{ version.author }}</b> changed
                <b>exclusivity</b> to
                <b>{{ version.newValue ? "Exclusive" : "Non-Exclusive" }}</b>
            </span>
      <span v-if="version.field === 'rank_featured'">
          <b>{{ version.author }}</b> changed
          <b>featured</b> to
          <b>{{ version.newValue ? "Yes" : "No" }}</b>
      </span>
      <span v-if="version.field === 'ai_approved'">
          <b>{{ version.author }}</b> changed
          <b>AI Approved</b> to
          <b>{{ version.newValue ? "Yes" : "No" }}</b>
      </span>
      <span v-if="version.field === 'status'">
                <b>{{ version.author }}</b> changed
                <b>{{ version.field }}</b> to
                <b>{{ humanize(version.newValue) }}</b>
            </span>
      <span v-else-if="version.field === 'notes'">
                <b>{{ version.author }}</b> added a Note:
                <b>{{ version.newValue }}</b>
            </span>
      <span v-else-if="version.field === 'data'">
                <b>{{ version.author }}</b> uploaded a new asset
            </span>
      <span v-else-if="version.field === 'release_form_id'">
                <b>{{ version.author }}</b>
                <span v-if="version.event === 'destroy'">
                    removed a release form
                </span>
                <span v-else>
                    added a release form
                </span>
            </span>
    </div>

  </div>
</template>

<script>
import GeneralMixins from "../../../mixins/GeneralMixins";

export default {
  props: ['version'],

  methods: {
    keywordsDiff(oldKeywords, newKeywords) {
      const o = new Set(oldKeywords)
      const n = new Set(newKeywords)

      let removedKeywords = new Set([...o].filter(x => !n.has(x)));
      let addedKeywords = new Set([...n].filter(x => !o.has(x)));

      let obj = {}
      if (addedKeywords.size > 0) {
        obj.added = [...addedKeywords]
      }
      if (removedKeywords.size > 0) {
        obj.removed = [...removedKeywords]
      }

      return obj
    },

    keywordsDiffText(oldKeywords, newKeywords, propertyName) {
      let diff = this.keywordsDiff(oldKeywords, newKeywords)
      let str = ""
      if (diff.added && diff.added.length) {
        if (diff.added.length <= 4) {
          if (diff.added.length > 1) {
            str += `added ${diff.added.slice(0, diff.added.length - 1).join(', ')} <b>and</b> ${diff.added[diff.added.length - 1]} to <b>${propertyName}</b>`
          } else {
            str += `added ${diff.added[0]} to <b>${propertyName}</b>`
          }

        } else {
          str += `added ${diff.added[0]} <b>and</b> ${diff.added.length - 1} other <b>${propertyName}</b>`
        }
      }

      if (diff.removed) {
        if (diff.removed.length <= 4) {
          str += `removed ${diff.removed.join(', ')} from <b>${propertyName}</b>`
        } else {
          str += `removed ${diff.removed[0]} <b>and</b> ${diff.removed.length - 1} other <b>${propertyName}</b>`
        }
      }
      return str
    },

    tagsDiffText(oldTagIds, newTagIds) {
      let oldTagNames = oldTagIds.map(id => window.tagStore.findTag(id)).filter(tag => tag).map(obj => obj.tag.name)
      let newTagNames = newTagIds.map(id => window.tagStore.findTag(id)).filter(tag => tag).map(obj => obj.tag.name)
      return this.keywordsDiffText(oldTagNames, newTagNames, "tags")
    },

    categoriesDiffText(oldTagIds, newTagIds) {
      let oldNames = oldTagIds.map(id => window.categoriesStore.findCategory(id)).filter(tag => tag).map(obj => obj.name)
      let newNames = newTagIds.map(id => window.categoriesStore.findCategory(id)).filter(tag => tag).map(obj => obj.name)
      return this.keywordsDiffText(oldNames, newNames, "categories")
    }
  },
  mixins: [GeneralMixins]
}
</script>

<style scoped>
b {
  font-weight: 600;
}
</style>